import React from "react";
import TextInput from "../../layout/TextInput";
import isEmailAddress from "../../utils/isEmailAddress";
import isInputEmpty from "../../utils/isInputEmpty";
import * as authService from "../../actions/auth.actions";
import { HOME_PAGE, SERVER_DOWN } from "../../Constants";
import { useApiResponse } from "../../context/ApiResponseContext";
import Alert from "../../layout/Alert";

export default function ResetPassword() {
  const [apiResponse, setApiResponse] = useApiResponse();
  const [values, setValues] = React.useState({
    emailAddress: "",
    emailAddressErr: false,
    emailAddressErrText: "Email address format is incorrect",

    resetToken: "",
    resetTokenErr: false,
    resetTokenErrText: "Invalid password reset token",

    newPassword: "",
    newPasswordErr: false,
    newPasswordErrText: "Password cannot be empty",

    resetTokenIsSend: false,
  });

  const resetInputValidationErrors = () => {
    setApiResponse({});
    setValues((prevValues) => {
      return { ...prevValues, emailAddressErr: false };
    });
  };

  const inputHandler = (e) => {
    setValues((prevValues) => {
      return { ...prevValues, [e.target.id]: e.target.value };
    });
  };

  const isUserInputValid = () => {
    const isInvalidEmail = !isEmailAddress(values.emailAddress);

    if (values.resetTokenIsSend) {
      const isResetTokenEmpty = isInputEmpty(values.resetToken);
      const isNewPasswordEmpty = isInputEmpty(values.newPassword);

      setValues((prevValues) => {
        return {
          ...prevValues,
          emailAddressErr: isInvalidEmail,
          resetTokenErr: isResetTokenEmpty,
          newPasswordErr: isNewPasswordEmpty,
        };
      });

      return !isInvalidEmail && !isResetTokenEmpty && !isNewPasswordEmpty;
    } else {
      setValues((prevValues) => {
        return { ...prevValues, emailAddressErr: isInvalidEmail };
      });
    }

    return !isInvalidEmail;
  };

  const handlePasswordReset = async (event) => {
    event.preventDefault();
    resetInputValidationErrors();
    if (isUserInputValid()) {
      const response = await authService.verifyTokenAndChangePassword({
        email_address: values.emailAddress,
        resetToken: values.resetToken,
        newPassword: values.newPassword,
      });

      if (!response) {
        console.log(SERVER_DOWN);
        return;
      }

      setApiResponse(response.data);

      if (response.status === 200) {
        authService.loginUser({
          email_address: values.emailAddress.trim(),
          password: values.newPassword.trim(),
          keepMeLoggedIn: false,
        });
        setTimeout(() => {
          window.location.href = HOME_PAGE;
        }, 2000);
      }

      if (response.status === 500) {
        console.log(response);
      }
    }
  };
  const handleSendResetEmail = async (event) => {
    event.preventDefault();
    resetInputValidationErrors();

    if (isUserInputValid()) {
      const response = await authService.sendPasswordResetToken({
        email_address: values.emailAddress,
      });
      if (!response) {
        console.log(SERVER_DOWN);
        return;
      }

      setApiResponse(response.data);

      if (response.status === 200) {
        setValues((prevValues) => {
          return { ...prevValues, resetTokenIsSend: true };
        });
      }

      if (response.status === 500) {
        console.log(response);
      }
    }
  };

  return (
    <div>
      <h1>Reset Password</h1>
      {apiResponse.message && <Alert text={apiResponse.message} />}
      {apiResponse.notFound && (
        <Alert type="error" text={apiResponse.notFound} />
      )}
      {apiResponse.invalidValue && (
        <Alert type="error" text={apiResponse.invalidValue} />
      )}
      {apiResponse.passwordConstraint && (
        <Alert type="error" text={apiResponse.passwordConstraint} />
      )}
      <form className="paddingtop20" action="#">
        <TextInput
          disabled={values.resetTokenIsSend}
          id="emailAddress"
          value={values.emailAddress}
          placeholder="E-mail address"
          isError={values.emailAddressErr}
          errorText={values.emailAddressErrText}
          onChange={inputHandler}
        />
        {values.resetTokenIsSend && (
          <>
            <TextInput
              disabled={values.resetTokenVerified}
              id="resetToken"
              value={values.resetToken}
              placeholder="Password reset token"
              isError={values.resetTokenErr}
              errorText={values.resetTokenErrText}
              onChange={inputHandler}
            />
            <TextInput
              id="newPassword"
              type="password"
              value={values.newPassword}
              placeholder="New password"
              isError={values.newPasswordErr}
              errorText={values.newPasswordErrText}
              onChange={inputHandler}
            />
          </>
        )}

        <input
          className="button"
          onClick={
            values.resetTokenIsSend ? handlePasswordReset : handleSendResetEmail
          }
          type="submit"
          value={values.resetTokenIsSend ? "Reset" : "Send e-mail"}
        ></input>
      </form>
    </div>
  );
}
